(function(){

function initCollectionTabs(section){

if(!section) return;





/* ======================
TAB SWITCH
====================== */

const tabs =
section.querySelectorAll(
".ctp-tab"
);

const panels =
section.querySelectorAll(
".ctp-panel"
);

tabs.forEach((tab)=>{

tab.addEventListener(

"click",

function(){

tabs.forEach(
(t)=>
t.classList.remove(
"active"
)
);

panels.forEach(
(p)=>
p.classList.remove(
"active"
)
);

this.classList.add(
"active"
);

const panel =
section.querySelector(

`[data-panel="${this.dataset.tab}"]`

);

if(panel){

panel.classList.add(
"active"
);

}

}

);

});






/* ======================
SLIDER
====================== */

const autoplay =
section.dataset.autoplay
==="true";

const autoplaySpeed =
Number(
section.dataset.speed
)||3500;

panels.forEach(

(panel)=>{

const track =
panel.querySelector(
".ctp-track"
);

if(!track)
return;





/* GRID DETECT */

const desktopGrid =
section.classList.contains(
"desktop-grid"
);

const mobileGrid =
section.classList.contains(
"mobile-grid"
);

if(
desktopGrid ||
(
window.innerWidth<768
&&
mobileGrid
)
){

return;

}






const next =
panel.querySelector(
".ctp-next"
);

const prev =
panel.querySelector(
".ctp-prev"
);

let auto;

function cardWidth(){

const card =
track.querySelector(
".ctp-card"
);

if(!card)
return 400;

return (
card.offsetWidth
+
20
);

}






/* ARROWS */

function nextSlide(){

track.scrollBy({

left:
cardWidth(),

behavior:
"smooth"

});

}

function prevSlide(){

track.scrollBy({

left:
-cardWidth(),

behavior:
"smooth"

});

}

if (next) {
  next.addEventListener("click", nextSlide);
}

if (prev) {
  prev.addEventListener("click", prevSlide);
}






/* AUTOPLAY */

function start(){

if(
!autoplay
)
return;

stop();

auto=
setInterval(

()=>{

if(

track.scrollLeft
+
track.clientWidth
>=
track.scrollWidth
-
50

){

track.scrollTo({

left:0,

behavior:
"smooth"

});

}

else{

nextSlide();

}

},

autoplaySpeed

);

}

function stop(){

clearInterval(
auto
);

}

start();

panel.addEventListener(
"mouseenter",
stop
);

panel.addEventListener(
"mouseleave",
start
);






/* DRAG */

let drag=false;

let startX=0;

let left=0;

track.addEventListener(

"mousedown",

(e)=>{

drag=true;

startX=
e.pageX;

left=
track.scrollLeft;

track.style.cursor=
"grabbing";

}

);

window.addEventListener(

"mouseup",

()=>{

drag=false;

track.style.cursor=
"grab";

}

);

track.addEventListener(

"mousemove",

(e)=>{

if(
!drag
)
return;

e.preventDefault();

track.scrollLeft=

left

-

(

e.pageX

-

startX

)

*1.5;

}

);






/* TOUCH */

track.addEventListener(

"touchstart",

(e)=>{

startX=

e.touches[0]
.pageX;

left=

track.scrollLeft;

}

);

track.addEventListener(

"touchmove",

(e)=>{

track.scrollLeft=

left

-

(

e.touches[0]
.pageX

-

startX

);

}

);






/* QUICK ADD */

panel

.querySelectorAll(

".ctp-quick-add"

)

.forEach(

(button)=>{

button.addEventListener(

"click",

async function(e){

e.preventDefault();

e.stopPropagation();

try{

this.disabled=true;

this.innerHTML="✓";

await fetch(

"/cart/add.js",

{

method:"POST",

headers:{

"Content-Type":

"application/json"

},

body:

JSON.stringify({

id:

this.dataset.product,

quantity:1

})

}

);

document.dispatchEvent(

new CustomEvent(

"cart:refresh"

)

);

setTimeout(()=>{

this.innerHTML="＋";

this.disabled=false;

},1200);

}

catch{

this.innerHTML="!";

setTimeout(()=>{

this.innerHTML="＋";

this.disabled=false;

},1200);

}

}

);

}

);

}

);

}






/* ======================
LOAD
====================== */

document.addEventListener(

"DOMContentLoaded",

function(){

document

.querySelectorAll(

".ctp-section"

)

.forEach(

initCollectionTabs

);

}

);






/* ======================
SHOPIFY EDITOR
====================== */

document.addEventListener(

"shopify:section:load",

function(e){

initCollectionTabs(
e.target
);

}

);

})();